var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{attrs:{"options":{
    placement: 'top',
    modifiers: { offset: { offset: '0, 5px' } },
  }}},[_c('div',{staticClass:"popper pa-3 text-left",staticStyle:{"min-width":"300px","max-width":"480px"}},[_vm._v(" "+_vm._s(_vm.getTooltipTextBySlug('campaigns_unrestricted_gift_link'))+" ")]),_c('div',{staticClass:"d-flex ml-2",attrs:{"slot":"reference"},slot:"reference"},[_c('icons-question',{staticClass:"pointer",attrs:{"width":"20","height":"20","color":"#62646A"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }